import { useState, useEffect } from "react"
import { get, post } from "../../utils/apiClient"
import toast from "react-hot-toast"

const UserSettings = ({ queueLevelData }) => {
  const [loading, setLoading] = useState(true)
  const [toggleNotificationSetting, setToggleNotificationSetting] =
    useState(true)

  const fetchSettings = async () => {
    setLoading(true)
    try {
      const data = await get(`/manage/user/settings`)
      setToggleNotificationSetting(data?.value === "false" ? false : true)
      setLoading(false)
    } catch (error) {
      console.error("Failed to fetch setting", error)
      setLoading(false)
    }
  }

  const setSettings = async (value) => {
    try {
      await post(`/manage/user/settings`, {
        name: "sendOutBoundFaxNotificationEmail",
        value,
      })
      toast.success("Setting saved successfully", {
        duration: 5000,
      })
    } catch (error) {
      console.error("Failed to fetch setting", error)
      setToggleNotificationSetting(!value)
    }
  }

  useEffect(() => {
    fetchSettings()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="faxes-content">
      {loading ? (
        <div className="loading-container-fax-list">
          <div className="loading-message">Loading...</div>
        </div>
      ) : (
        <>
          <div
            className="search-container"
            style={{
              width: "100%",
              alignItems: "end",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "20px",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <span style={{ marginRight: "10px", marginLeft: "20px" }}>
                  Send Outbound Fax Notification Email:
                </span>
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={toggleNotificationSetting}
                    onChange={() => {
                      setToggleNotificationSetting(!toggleNotificationSetting)
                      setSettings(!toggleNotificationSetting)
                    }}
                  />
                  <span
                    className={`slider ${
                      toggleNotificationSetting ? "on" : "off"
                    }`}
                  >
                    <span className="switch-label">
                      {toggleNotificationSetting ? "ON" : "OFF"}
                    </span>
                  </span>
                </label>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default UserSettings
